export var LicenseTypes;
(function (LicenseTypes) {
    LicenseTypes["DashpivotContributor"] = "Dashpivot Contributor";
    LicenseTypes["DashpivotVisitor"] = "Dashpivot Visitor";
    LicenseTypes["SitematePaidUser"] = "Sitemate Paid User";
    LicenseTypes["SitemateFreeUser"] = "Sitemate Free User";
})(LicenseTypes || (LicenseTypes = {}));
